import { Component, OnInit } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

interface CashOutReasonButton {
  text: string;
  value: string;
  imageName: string;
  default?: boolean;
  goal?: number;
}

@Component({
  selector: 'app-cash-out-reason',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['./cash-out-reason.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})

export class CashOutReasonComponent extends ButtonStepComponent implements OnInit {
  title: string = "What is your reason for cashing out?";

  buttonList: CashOutReasonButton[] = [
    { text: 'Reduce High Interest debt', value: 'reduce-debt', imageName: 'interest-debt', default: true },
    { text: 'Home Improvement', value: 'home-improvement', imageName: 'home-improvement' },
    { text: 'Emergency use', value: 'emergency', imageName: 'emergency-use' },
    { text: 'Other', value: 'other', imageName: 'dont-know' },
  ];

  ngOnInit() {
    if (this.checkIsHomeEquity()) {
      this.title = "What is your reason for getting home equity?";
    }

    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('cashOutReason', this.control);
  }

  checkIsHomeEquity(): boolean {
    const urlStr = window.location.href;
    try {
      const url = new URL(urlStr);
      const validDomains = [
        'freerateupdate.com',
        'searchmortgagerate.com',
        'homeequitychoice.com',
        'homeequityoptions.com',
        'besthomeequityloan.com'
      ];

      const domainMatch = true; //validDomains.some(domain => url.hostname === domain || url.hostname.endsWith('.' + domain));
      const pathMatch = url.pathname === '/communication/rates-form';

      const params = new URLSearchParams(url.search);
      const isHeloc = params.get('FormType')?.toLowerCase() === 'heloc';
      const isNotPurchase = params.get('lp_button')?.toLowerCase() !== 'purchase';

      return domainMatch && pathMatch && isHeloc && isNotPurchase;
    } catch {
      return false;
    }
  }

  submit(button: CashOutReasonButton) {
    if(button?.goal) {
      this.analyticsService.trackGoal(button.goal);
    }
    super.submit(button);
  }
}
